import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { constants } from 'common/helpers'
import { FormattedMessage } from 'sb-react-intl'

import UserInfo from '../UserInfo/UserInfo'
import ActionButtons from '../ActionButtons/ActionButtons'

import messages from './messages'
import s from './Reply.scss'


class Reply extends PureComponent {
  handleVote = ({ isUseful }) => {
    const { onVote, reply, reviewId } = this.props
    const initialIsUseful = reply.isUseful

    if (initialIsUseful === isUseful) {
      isUseful = null
    }

    if (Boolean(onVote)) {
      onVote({ isUseful, replyId: reply.id, reviewId })
    }
  }

  render() {
    const { reply, currentUserId } = this.props
    const { id, user, user: { id: authorId } = {}, date, text, isUseful, likeCount, dislikeCount } = reply

    return (
      <div className={s.reply}>
        <div className={s.header}>
          <UserInfo avatarClassName={s.replyAvatar} {...user} />
          <div className={s.date}>
            {moment(date).format('MM/DD/YYYY')}
          </div>
        </div>
        <div className={s.body}>
          <div className={s.text} data-testid="replyMessage">
            {text}
          </div>
          {
            currentUserId !== authorId && (
              <div className={s.helpful}>
                <div className={s.helpfulText}>
                  <FormattedMessage {...messages.helpful} />
                </div>
                <ActionButtons
                  id={id}
                  isUseful={isUseful}
                  likeCount={likeCount}
                  dislikeCount={dislikeCount}
                  onVote={this.handleVote}
                  dataTestIds={{
                    likeButton: constants.testIds.reply.likeButton,
                    dislikeButton: constants.testIds.reply.dislikeButton,
                  }}
                />
              </div>
            )
          }
        </div>
      </div>
    )
  }
}

Reply.propTypes = {
  reply: PropTypes.shape({
    id: PropTypes.number.isRequired,
    user: PropTypes.object.isRequired,
    date: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    isUseful: PropTypes.bool,
    likeCount: PropTypes.number.isRequired,
    dislikeCount: PropTypes.number.isRequired,
  }).isRequired,
  currentUserId: PropTypes.number,
  onVote: PropTypes.func.isRequired,
}


export default Reply
